<template>
  <div id="appbar">
    <b-navbar
      toggleable="md"
      type="dark"
      fixed="top">
      <div class="container">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand to="/" exact>
          <img :src="logo" />
        </b-navbar-brand>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav>
            <b-nav-item
              v-for="route in routes"
              :key="route.name"
              :to="route.path"
              :exact="route.exact">
              {{route.label || route.name}}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
  </div>
</template>
<script>
import Vue from "vue";
import { RouteConfig } from 'vue-router';
import Router from '../router';

export default Vue.extend({
  data() {
    return {
      logo: require("@/assets/logo_32.png"),
      routes: []
    };
  },
  mounted() {
    this.routes = Router.options.routes.filter(x => !!x.label);
  },
})
</script>